import { render } from "./PositionList.vue?vue&type=template&id=779c8d9f"
import script from "./PositionList.vue?vue&type=script&lang=js"
export * from "./PositionList.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\Euc.Web.EucCz\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__